import React from 'react';
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import './../Slider/swiper.css';

import { HiOutlineArrowRight } from 'react-icons/hi';

// import required modules
import { Pagination } from 'swiper/modules';

import SliderThree from './../Slider/img/Front-BG3.jpg';
import SliderFour from './../Slider/img/FrontBG4.jpg';

import SliderFive from './../Slider/img/FrontBG5.jpg';

export default function Slider() {
   return (
      <Swiper
         direction={'vertical'}
         pagination={{
            clickable: true,
         }}
         // autoplay={{
         //    delay: 2500,
         //    disableOnInteraction: false,
         // }}
         modules={[Pagination]}
         className="mySwiper"
      >
         <SwiperSlide>
            <img src={SliderFive} alt="" />
            <div className='slide_content--block' >
               <div className="slide_text--box --slide_content-box">
                  <h2>Let's Create Your Dream Interior</h2>
                  <h3>The world needs innovators and problem solvers who turn <br />challenges into greater opportunities.</h3>
                  <Link>
                     <button type='submit' className='slide_button'>
                        <span>Get Started</span>
                        <span className='arrow_icon'><HiOutlineArrowRight /></span>
                     </button>
                  </Link>
               </div>
            </div>
         </SwiperSlide>
         <SwiperSlide>
            <img src={SliderFour} alt="" />
            <div className='slide_content--block'>
               <div className="slide_text--box --slide_content-box">
                  <h2>Let's Create Your Dream Interior</h2>
                  <h3>The world needs innovators and problem solvers who turn <br />challenges into greater opportunities.</h3>
                  <Link>
                     <button type='submit' className='slide_button'>
                        <span>Get Started</span>
                        <span className='arrow_icon'><HiOutlineArrowRight /></span>
                     </button>
                  </Link>
               </div>
            </div>
         </SwiperSlide>
         <SwiperSlide>
            <img src={SliderThree} alt="" />
            <div className='slide_content--block'>
               <div className="slide_text--box --slide_content-box">
                  <h2>Let's Create Your Dream Interior</h2>
                  <h3>The world needs innovators and problem solvers who turn <br />challenges into greater opportunities.</h3>
                  <Link>
                     <button type='submit' className='slide_button'>
                        <span>Get Started</span>
                        <span className='arrow_icon'><HiOutlineArrowRight /></span>
                     </button>
                  </Link>
               </div>
            </div>
         </SwiperSlide>
      </Swiper>
   )
}
